import React from "react";
import { getDependentFormFields } from "../../services/restAPI/RestApi";
import { decode } from "js-base64";
import { store } from "../../appRedux/store/Store";
import {
   setGridSqlValues,
   setListTableResponses,
   setSqlValues,
} from "../../appRedux/actions/FormsV2";
import "../../components/FormsV2/FormComplete/FormComplete.less";
import moment from "moment";
import { Message } from "../BP2Components";
import { createElementFromHTML } from "../../util/Scripts";
import { getAlert, getAlerts } from "../../services/restAPI/RestApi";
import RenderDevEditForm from "../RenderDevEditForm/RenderDevEditForm";

export const isInNuxtContext = () => {
   if (typeof window !== "undefined") {
      return window.__NUXT__ !== undefined || window.location.pathname.startsWith("/pl/");
   }
   return false;
};

export const setUrlTo = (url) => {
   if (isInNuxtContext()) {
      const event = new CustomEvent("nuxt:navigate", {
         detail: { path: url, replace: false },
      });
      window.dispatchEvent(event);
   } else {
      window.location.assign(url);
   }
};

const additionalSaveDataRegistry = new Map();

export const registerAdditionalSaveData = (formKey, data) => {
   additionalSaveDataRegistry.set(formKey, data);
};

export const unregisterAdditionalSaveData = (formKey) => {
   additionalSaveDataRegistry.delete(formKey);
};

export const PRINT_STYLES = `
@page {
   margin-top:25px;
   margin-bottom:30px;
}

@media print {
   * {
      font-family: sans-serif !important;
   }           
   .ant-radio-wrapper {
      display: none !important;
   }
   #field-buyer_name{
      word-wrap: break-word;
      overflow-wrap: break-word;
   }
   .prewiev-style-small-column{
      width: 250px
   }

   .ant-radio-wrapper-checked {
      display: inline-block !important;
   }           
   .ant-radio {
      display: none !important;
   }        
   .ant-select-search--inline {
      display: none
   }

   .bp2input .text-field__input {
      word-wrap: break-word;
      display: none !important;
   }


   .table-plugin{
      .super-select__control{
         border: none !important;
         width: 40px !important;
      }
      bp2input .text-field__input {
         width: 50px !important
         word-wrap: break-word;
         display: none !important;
      }
   
   }
   .react-datepicker-wrapper .react-datepicker__input-container {
      width: 70% !important;
   }

   .template-in-form th, .template-in-form td{
      padding: 0px !important;
      padding-left: 5px !important;
   }

   .ant-select-disabled{
      background: transparent !important;
   }

   #ta-jedna-tablica-ktora-zle-wyglada{
      width: 50% !important;
   }
   
   .super-select__control{
      border: none !important;
      background: transparent !important;
   }

 .react-datepicker__close-icon::after{
      display: none !important;
   }

   .bp2datepicker{
      width: 200px
   } 

   .super-select__value-container{
      width: 50vw !important;
      border: none !important;
   }

   .super-select__indicator, .super-select__dropdown-indicator {
      display: none !important;
   }

   .anticon, .anticon-down, .ant-select-arrow-icon{
      display: none !important;
   }



   .ant-select-selection, input, .ant-input-number, textarea, ant-select, .bp2input text-field__input, .field_no_invoice, .textarea-field__input {
      border: none !important;
      background: transparent !important;
      
   }
   textarea {
      resize: none !important;
   }
   .ant-select-selection__choice__remove, .ant-select-arrowm .super-select__indicators, .anticon anticon-down, 
   .ant-select-arrow-icon, .super-select__indicator, .super-select__dropdown-indicator,  {
      display: none !important;

   }
   .ant-input::placeholder{
      opacity: 0;
   }
   .react-datepicker__close-icon react-datepicker__close-icon--disabled{
      display: none !important;
   }

   .list-widget {
      table {
         table-layout: fixed !important;
         overflow-wrap: break-word !important;
         .ant-table-column-title {
            overflow-wrap: break-word !important;
            white-space: pre-line !important;
         }
         button {
            display: none !important;
         }
         td,th {
            width: 100px !important;
            padding: 4px !important;
         }
         i, svg {
            display: none !important;
         }
         .actions-column {
            padding: 0px !important;
            width: 0px !important;
            border-left-color: transparent !important;
            border-top-color: transparent !important;
            border-bottom-color: transparent !important;
            span {
               display: none !important;
            }
         }
      }
   }
   
}`;

export const handleGridTechname = (techname) => {
   try {
      const charsToReplace = ["#", ":", " ", "/"];

      const changedTechname = charsToReplace.reduce((prev, curr) => {
         return prev.replaceAll(curr, "_");
      }, techname);

      return changedTechname;
   } catch (e) {
      return techname;
   }
};

export const putElementsInGridTemplate = (elements, isVisible) => {
   let finalGridTemplateAreas = "";
   const areas = [];
   elements.forEach((element) => {
      const hasDependentVisibility = element.showHideFields?.length > 0;
      const shouldBeInGrid =
         window.devLogged ||
         (hasDependentVisibility ? !isVisible || isVisible(element) : element.hidden !== "1");

      if (!shouldBeInGrid) {
         return;
      }
      const technameForGrid = handleGridTechname(element.tech_name);
      // Delete listTable conditional when backend fixes it
      if (element.position === "left" && element?.type !== "listTable") {
         let indexOfLastFilledLeftRow;
         let index = areas.length - 1;
         for (; index >= 0; index--) {
            if (areas[index][0] !== ".") {
               indexOfLastFilledLeftRow = index;
               break;
            }
         }
         // See if there are any filled left rows
         if (indexOfLastFilledLeftRow || indexOfLastFilledLeftRow === 0) {
            if (indexOfLastFilledLeftRow === areas.length - 1) {
               // If the last filled left row is the last one of elements array, add new row
               areas.push([technameForGrid, "."]);
            } else {
               // If found row is not last, just change value of following row to the elements tech_name
               areas[indexOfLastFilledLeftRow + 1][0] = technameForGrid;
            }
            // Check if there are any fields with filled right column
         } else if (areas.length > 0) {
            // If there is, just modify first row. This is only possible if there are any right aligned elements first
            areas[0][0] = technameForGrid;
            // If not, just add new row
         } else {
            areas.push([technameForGrid, "."]);
         }
         // Delete listTable conditional when backend fixes it
      } else if (element.position === "right" && element?.type !== "listTable") {
         let indexOfLastRightFilledRow;
         let index = areas.length - 1;
         for (; index >= 0; index--) {
            if (areas[index][1] !== ".") {
               indexOfLastRightFilledRow = index;
               break;
            }
         }
         // See if there are any filled right rows
         if (indexOfLastRightFilledRow || indexOfLastRightFilledRow === 0) {
            if (indexOfLastRightFilledRow === areas.length - 1) {
               // If the last filled right row is the last one of elements array, add new row
               areas.push([".", technameForGrid]);
            } else {
               // If found row is not last, just change value of following row to the elements tech_name
               areas[indexOfLastRightFilledRow + 1][1] = technameForGrid;
            }
            // If there are any unfilled right rows, modify the first element
         } else if (areas.length > 0) {
            areas[0][1] = technameForGrid;
            // If not, just add new row
         } else {
            areas.push([".", technameForGrid]);
         }
         // Delete listTable conditional when backend fixes it
      } else if (element.position === "page_width" || element?.type === "listTable") {
         areas.push([technameForGrid, technameForGrid]);
      }
   });

   if (areas) {
      areas.forEach((area) => {
         finalGridTemplateAreas += `"${area[0]} ${area[1]}" `;
      });
   }
   return finalGridTemplateAreas;
};

export const checkIfOptionAvailable = (allOptions, value) => {
   return !!allOptions.find((option) => option.props.value === value) ? value : null;
};

export const handleChangedRelatedField = (
   element,
   form,
   setFieldsInfo,
   allFieldsWithAlerts,
   formId,
   intl,
   formKey,
   gridDataId,
   changeFieldPendingStatus,
   fieldEnumMap,
) => {
   const { getFieldValue, getFieldsValue, setFieldsValue } = form;

   if (
      element?.isRelatedWithOtherFields &&
      getFieldValue &&
      getFieldsValue &&
      setFieldsValue &&
      formId
   ) {
      const getter = formKey ? additionalSaveDataRegistry.get(formKey) : null;
      const registeredData = getter ? getter() : null;
      const actualValues = {
         ...transformFormValuesForRequest(getFieldsValue(), null, undefined, fieldEnumMap),
         ...(registeredData || {}),
      };
      changeFieldPendingStatus && changeFieldPendingStatus(true);

      const updateSqlValuesDispatch = gridDataId
         ? (data) => store.dispatch(setGridSqlValues({ [gridDataId]: data }))
         : (data) => store.dispatch(setSqlValues(data));

      const handleCascadeField = (cascadeFieldKey) => {
         const updatedValues = transformFormValuesForRequest(
            form.getFieldsValue(),
            null,
            undefined,
            fieldEnumMap,
         );
         return getDependentFormFields(
            formId,
            formKey,
            updatedValues,
            cascadeFieldKey,
            gridDataId
               ? store?.getState()?.formsv2?.formInfo?.mainFormRef?.getFieldsValue()
               : undefined,
         )
            .then((cascadeRes) =>
               handleRelatedFieldsResponse(
                  changeFieldPendingStatus,
                  { tech_name: cascadeFieldKey, formAction: false },
                  form,
                  formId,
                  formKey,
                  updatedValues,
                  cascadeRes.data.default,
                  setFieldsValue,
                  setFieldsInfo,
                  allFieldsWithAlerts,
                  updateSqlValuesDispatch,
                  intl,
                  (data) => store.dispatch(setListTableResponses(data)),
                  undefined,
                  fieldEnumMap,
               ),
            )
            .catch(() => {
               console.error("Error while updating cascade dependent fields");
            });
      };

      getDependentFormFields(
         formId,
         formKey,
         actualValues,
         element.tech_name,
         gridDataId
            ? store?.getState()?.formsv2?.formInfo?.mainFormRef?.getFieldsValue()
            : undefined,
      )
         .then((res) =>
            handleRelatedFieldsResponse(
               changeFieldPendingStatus,
               element,
               form,
               formId,
               formKey,
               actualValues,
               res.data.default,
               setFieldsValue,
               setFieldsInfo,
               allFieldsWithAlerts,
               updateSqlValuesDispatch,
               intl,
               (data) => store.dispatch(setListTableResponses(data)),
               handleCascadeField,
               fieldEnumMap,
            ),
         )
         .catch(() => {
            Message.error(
               intl.formatMessage({ id: "formComplete.handleChangedRelatedFieldError" }),
            );
         })
         .finally(() => {
            changeFieldPendingStatus && changeFieldPendingStatus(false);
         });
   } else {
      changeFieldPendingStatus && changeFieldPendingStatus(false);
   }
};

export const handleRelatedFieldsResponse = async (
   changeFieldPendingStatus,
   element,
   form,
   formId,
   formKey,
   previousValues,
   data,
   setFieldsValue,
   setFieldsInfo,
   allFieldsWithAlerts,
   updateSqlValues,
   intl,
   setListTableResponses,
   onCascadeField,
   fieldEnumMap,
) => {
   if (data) {
      const fieldsValues = {};
      const sqlOptions = {};
      const cascadeFields = [];
      // If put from button field - handle messages
      if (element.formAction === true) {
         const requestedFieldIsInResponse = data[element.tech_name] ? true : false;
         if (
            (requestedFieldIsInResponse && Object.keys(data)?.length === 1) ||
            Object.keys(data)?.length === 0
         ) {
            Message.error(intl.formatMessage({ id: "formComplete.prevDocNotFound" }), 6000);
         }
      }
      // If put from standard fields

      Object.keys(data).forEach((fieldKey) => {
         const fieldObject = data[fieldKey];
         if (
            fieldObject &&
            typeof fieldObject === "object" &&
            fieldObject.value &&
            fieldObject.value.meta &&
            fieldObject.value.columns &&
            Array.isArray(fieldObject.value.data)
         ) {
            setListTableResponses({
               [fieldKey]: fieldObject.value,
            });

            return;
         }
         const relatedFieldClassList =
            document.querySelector(`.field_${fieldKey}`)?.classList?.value || "";
         const relatedFieldType = relatedFieldClassList?.includes("_type_")
            ? relatedFieldClassList.split("_type_")[1]
            : "";
         const relatedFieldEnum = relatedFieldClassList?.includes("_enum_")
            ? relatedFieldClassList.split("_enum_")[1]
            : "";
         const relatedFieldPrecision = relatedFieldClassList?.includes("_prec_")
            ? relatedFieldClassList.split("_prec_")[1]
            : "";
         const fieldId = relatedFieldClassList?.includes("_id_")
            ? relatedFieldClassList.split("_id_")[1]
            : null;
         const hasAlert = relatedFieldClassList?.includes("has-alert-true");
         const assignFieldValue = (value) => {
            if (
               relatedFieldEnum === "dec" &&
               value !== "" &&
               value !== null &&
               relatedFieldPrecision &&
               !Number.isNaN(+value)
            ) {
               fieldsValues[fieldKey] = parseFloat(value).toFixed(relatedFieldPrecision);
            } else {
               fieldsValues[fieldKey] = value;
            }
         };
         // Set sql options if field is sql
         if (Array.isArray(fieldObject.sqlValues)) {
            sqlOptions[fieldKey] = fieldObject.sqlValues;
            const resolvedValue =
               typeof fieldObject.value === "object" && fieldObject.value !== null
                  ? fieldObject.value.value
                  : fieldObject.value;
            if (
               typeof resolvedValue === "number" ||
               typeof resolvedValue === "string" ||
               resolvedValue === null
            ) {
               assignFieldValue(resolvedValue);
            }
            if (
               (typeof resolvedValue === "number" || typeof resolvedValue === "string") &&
               fieldObject.sqlValues.some((opt) => String(opt.value) === String(resolvedValue))
            ) {
               cascadeFields.push(fieldKey);
            }
         } else if (
            relatedFieldType === "sql" &&
            (Array.isArray(fieldObject.value) || fieldObject.value === null)
         ) {
            // There are new options so we reset old selection
            sqlOptions[fieldKey] = fieldObject.value;
         } else if (
            typeof fieldObject.value === "number" ||
            typeof fieldObject.value === "string" ||
            typeof fieldObject.value === "object" || // grids get arrays
            fieldObject.value === null
         ) {
            assignFieldValue(fieldObject.value);
         } else if (typeof fieldObject.label === "string") {
            fieldsValues[fieldKey] = fieldObject.label;
         } else if (relatedFieldType === "file") {
            fieldsValues[fieldKey] = fieldObject;
         }
      });

      try {
         if (Object.keys(sqlOptions)?.length > 0) {
            // allValuesAreTheSame - to prevent running "updateSqlValues" function with previous values
            let allValuesAreTheSame = true;
            Object.keys(previousValues).forEach((key) => {
               if (
                  sqlOptions[key] &&
                  !(Array.isArray(sqlOptions[key]) && sqlOptions[key]?.length === 0) &&
                  previousValues[key] !== sqlOptions[key]
               ) {
                  allValuesAreTheSame = false;
               }
            });
            if (allValuesAreTheSame === false) {
               updateSqlValues({ ...sqlOptions });
            }
         }

         // allValuesAreTheSame - to prevent running "setFieldsValue" function with previous values
         let allValuesAreTheSame = true;
         Object.keys(fieldsValues).forEach((key) => {
            if (previousValues[key] !== fieldsValues[key]) {
               allValuesAreTheSame = false;
            }
         });
         if (allValuesAreTheSame === false) {
            setFieldsValue(fieldsValues);
         }
         await Promise.all(cascadeFields.map((fieldKey) => onCascadeField?.(fieldKey)));
      } catch (err) {
         console.log("Error while updating dependent fields");
      }
   }

   if (
      Object.keys(data).length > 0 &&
      Array.isArray(allFieldsWithAlerts) &&
      allFieldsWithAlerts?.length > 0
   ) {
      handleAllAlerts(
         allFieldsWithAlerts,
         form,
         formId,
         setFieldsInfo,
         changeFieldPendingStatus,
         fieldEnumMap,
      );
   } else {
      /* todo if field has alert and data is empty */
      /*  element.hasAlert &&
         handleFieldAlert(element.id, element.tech_name, form, formKey, setFieldsInfo); */
   }
};

export const renderDevInfo = (element) => {
   return (
      <>
         <span className="dev-info">
            techname: <b>{element?.tech_name}</b>
         </span>
         <span className="dev-info">
            id: <b>{element?.object.UIP_ID}</b>
         </span>
         <RenderDevEditForm element={element} />
      </>
   );
};

/**
 * Renders a template by replacing specific elements in the DOM based on their techname attribute.
 * Elements with techname values found in classNamesToHide are excluded from rendering.
 *
 * @param {string} template - The template string to be rendered, potentially encoded.
 * @param {Object} form - The form object used to retrieve field values.
 * @param {Array<string>} [classNamesToHide=[]] - An array of techname values that should not be rendered.
 */
export const renderTemplate = (formId, template, form, classNamesToHide = [], tryCount = 1) => {
   if (tryCount >= 5) return;
   try {
      // Select the container where the template will be rendered
      const templatePlace = document.getElementById(`template-${formId}`);
      // Check if the template place exists in the DOM
      if (!templatePlace) {
         throw Error;
      }
      if (templatePlace?.children?.length === 0 && template?.length > 0 && form) {
         const decodedTemplate = decodeURIComponent(template);
         const base64DecodedTemplate = decode(decodedTemplate);
         templatePlace.innerHTML = base64DecodedTemplate;

         const fieldsToBeReplaced = templatePlace.querySelectorAll("input"); // Almost all fields are <input> in php template
         const gridsToBeReplaced = templatePlace.querySelectorAll("textarea"); // But PHP says that grid is <textarea>
         const elementsToBeReplaced = [...fieldsToBeReplaced, ...gridsToBeReplaced]; // All field places in html template

         // Loop through each element that needs to be replaced
         if (templatePlace) {
            elementsToBeReplaced.forEach((element) => {
               // Get the techname attribute of the current element
               const techname = element.attributes.techname?.value;

               // Check if the current techname is in the list of names to hide
               const shouldHide = classNamesToHide.includes(techname);

               // If the element should not be hidden
               if (!shouldHide) {
                  const elementToReplace = document.querySelector(`.field_${techname}`);
                  // Payments
                  if (techname?.includes("_url")) {
                     elementToReplace.style.cursor = "pointer";
                     elementToReplace.removeAttribute("disabled");
                     elementToReplace.addEventListener("click", () =>
                        window.open(form.getFieldValue("payment_url"), "_blank"),
                     );
                  }

                  if (elementToReplace) {
                     let formElementToReplaceWith;
                     // Element is with possible alert or not
                     if (elementToReplace.classList.contains("has-alert-true")) {
                        formElementToReplaceWith = createElementFromHTML(
                           `<span class="field-with-alert-container"></span>`,
                        );
                        formElementToReplaceWith.appendChild(elementToReplace);
                        const alertElement = createElementFromHTML(
                           `<div id="tmpl-alert-${techname}" class="template-alert-container">
                              <svg
                                 width="20"
                                 height="20"
                                 viewBox="0 0 20 20"
                                 fill="none"
                                 xmlns="http://www.w3.org/2000/svg"
                              >
                                 <path
                                    d="M10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20ZM10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM9 5H11V7H9V5ZM9 9H11V15H9V9Z"
                                    fill="#EF4444"
                                 ></path>
                              </svg>
                              <span id="tmpl-alert-${techname}-text" class="field-alert-container__text"></span>
                           </div>`,
                        );
                        formElementToReplaceWith.appendChild(alertElement);
                     } else {
                        formElementToReplaceWith = elementToReplace;
                     }
                     templatePlace
                        .querySelector(`[techname="${techname}"]`)
                        .replaceWith(formElementToReplaceWith);
                  }
               } else {
                  // If the techname is in the hide list, remove the element from the DOM
                  element.remove();
               }
            });
         }
      }
   } catch (err) {
      // Because this function bases on DOM elements, we need to add mechanism to deal with render time
      // This solution tries to render template every 1000 if the template is available in the form
      setTimeout(() => {
         renderTemplate(formId, template, form, classNamesToHide, (tryCount += 1));
      }, 1000);
   }
};
// This is the function to get proper ID from the link. It has been copied from the old solution
export const getIdFromTheFileLink = (elementUrl) => {
   let id;
   if (elementUrl !== null && elementUrl !== undefined) {
      const parts = elementUrl.split(
         //eslint-disable-next-line
         /^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?/,
      );
      if (elementUrl.indexOf("?id=") >= 0) {
         id = parts[6].split("=")[1].replace("&usp", "");
         return id;
      } else {
         id = parts[5].split("/");
         let sortArr = id.sort((a, b) => {
            return b.length - a.length;
         });
         id = sortArr[0];
      }
   }
   return id;
};

export const buildFieldEnumMapFromForm = (formData) =>
   buildFieldEnumMap(
      (formData?.forms_data?.tab ?? []).flatMap((tab) => Object.values(tab?.elements ?? {})),
   );

export const buildFieldEnumMap = (elements) => {
   if (!elements) return {};
   const items = Array.isArray(elements) ? elements : Object.values(elements);
   return items.reduce((map, el) => {
      if (el.tech_name && el.enum) {
         map[el.tech_name] = el.enum;
      }
      return map;
   }, {});
};

export const transformFormValuesForRequest = (
   fieldsValues,
   transformString,
   useSqlValues,
   fieldEnumMap,
) => {
   const transformedFields = { ...fieldsValues };
   Object.keys(fieldsValues)?.forEach((fieldsKey) => {
      let fieldValue = fieldsValues?.[fieldsKey];
      // We need to transform boolean values to "1" and "0" because our PHP forms are a piece of shit and don't accept true and false
      if (typeof fieldValue === "boolean") {
         transformedFields[fieldsKey] = fieldValue ? "1" : "0";
         return;
         // We need to transform values of upload files to value of response that we got after uploading the files,
         // If there are many files provided, we take the last one
      } else if (
         typeof fieldValue === "object" &&
         fieldValue?.fileList?.[0]?.response?.uploadFile?.dtbId
      ) {
         transformedFields[fieldsKey] = fieldValue.fileList[0].response.uploadFile.dtbId;
      } else if (typeof fieldValue === "object" && fieldValue?.fileList?.length === 0) {
         transformedFields[fieldsKey] = undefined;
      } else if (
         typeof fieldValue === "object" &&
         fieldValue !== null &&
         fieldValue.isValid &&
         fieldValue.isValid()
      ) {
         //overwriting all fields wich "YYYY-MM-DD HH-mm-ss" will overwrite time to field wich contains only data and the other way round
         const enumType = fieldEnumMap?.[fieldsKey];
         const isDateField =
            enumType === "date" ||
            (!enumType && (fieldsKey.includes("date") || fieldsKey.includes("data")));
         const isTimeField =
            enumType === "time" || (!enumType && !isDateField && fieldsKey.includes("time"));
         if (isDateField) {
            transformedFields[fieldsKey] = moment(transformedFields[fieldsKey]).format(
               "YYYY-MM-DD",
            );
         } else if (isTimeField) {
            transformedFields[fieldsKey] = moment(transformedFields[fieldsKey]).format("HH:mm:ss");
         } else {
            transformedFields[fieldsKey] = moment(transformedFields[fieldsKey]).format(
               "YYYY-MM-DD HH:mm:ss",
            );
         }
      } else if (transformString && typeof fieldValue === "string") {
         // This should only be applied when we use origin forms. Backend needs to fix this
         transformedFields[fieldsKey] = fieldValue
            .replaceAll('"', "quote")
            .replaceAll("'", "quote")
            .replaceAll("/", "slash")
            .replaceAll("<", "test")
            .replaceAll(">", "test")
            .replaceAll("\\", "slash")
            .replaceAll("?", "%3F")
            .replaceAll("ą", "")
            .replaceAll("Ą", "")
            .replaceAll("ć", "")
            .replaceAll("Ć", "")
            .replaceAll("ę", "")
            .replaceAll("Ę", "")
            .replaceAll("ń", "")
            .replaceAll("Ń", "")
            .replaceAll("ó", "")
            .replaceAll("Ó", "")
            .replaceAll("ś", "")
            .replaceAll("Ś", "")
            .replaceAll("ż", "")
            .replaceAll("Ż", "")
            .replaceAll("ź", "")
            .replaceAll("Ź", "");
      } else if (!useSqlValues) {
         // If we have sql values, we need to transform the value to the value that is in the sql values
         const sqlValues = store?.getState()?.formsv2?.sqlValues;

         if (sqlValues && sqlValues[fieldsKey] && Array.isArray(sqlValues[fieldsKey])) {
            const sqlValue = sqlValues[fieldsKey].find(
               (sqlOption) => sqlOption.value === fieldValue,
            );
            if (sqlValue) {
               transformedFields[fieldsKey] = sqlValue.label;
            }
         }
      }
   });
   return transformedFields;
};

export const handleAllAlerts = (
   fields,
   form,
   formId,
   setFieldsInfo,
   changeFieldPendingStatus,
   fieldEnumMap,
) => {
   const fieldIdList = fields.map((field) => field.id);
   const formValues = {
      ...transformFormValuesForRequest(form?.getFieldsValue(), null, true, fieldEnumMap),
      easyForm: true,
      UIF_ID: formId,
   };
   changeFieldPendingStatus(true);
   getAlerts(fieldIdList, formValues)
      .then((res) => {
         const alertListObject = res.data.getAlerts;
         const convertedAlertObject = {};
         Object.keys(alertListObject).forEach((key) => {
            const techName = fields.find((field) => field.id === key)?.techName;
            if (alertListObject[key]?.length === 0) {
               convertedAlertObject[techName] = "";
            } else {
               convertedAlertObject[techName] = alertListObject[key][0][0];
            }
         });
         setFieldsInfo(convertedAlertObject);
      })
      .finally(() => {
         changeFieldPendingStatus(false);
      });
};

export const handleFieldAlert = (fieldId, techName, form, formKey, setFieldsInfo, fieldEnumMap) => {
   const formValues = transformFormValuesForRequest(
      form?.getFieldsValue(),
      null,
      true,
      fieldEnumMap,
   );
   getAlert(fieldId, formValues, formKey).then((res) => {
      if (res?.data?.getAlert[0]) {
         setFieldsInfo((prev) => ({
            ...prev,
            [techName]: res.data.getAlert[0][0],
         }));
      } else if (res?.data?.getAlert?.length === 0) {
         setFieldsInfo((prev) => ({
            ...prev,
            [techName]: "",
         }));
      }
   });
};

export const validateGridRows = () => {
   const gridRequestFieldId = store?.getState()?.formsv2?.formInfo?.gridRequestFieldId;
   const gridFormRefs = store?.getState()?.formsv2?.gridFormRefs;
   const gridRequestObject = {};

   let isTableValid = true;
   if (gridRequestFieldId && gridFormRefs?.length > 0) {
      let idx = 0;
      gridFormRefs.forEach(({ ref }) => {
         if (isTableValid) {
            ref.validateFields((err, values) => {
               if (!Object.keys(values).length) return;

               if (err) {
                  // Check if grid rows are properly validated. If visible fields of form are empty, form should
                  // should move on
                  const fieldValues = Object.entries(values);

                  let allVisibleFieldsEmpty = true;
                  for (const [key, value] of fieldValues) {
                     if (
                        allVisibleFieldsEmpty &&
                        !Object.keys(err)?.includes(key) &&
                        value !== undefined &&
                        value !== null &&
                        value !== "" &&
                        !document.querySelector(`[column="${key}"]`)?.classList?.contains("hidden")
                     ) {
                        allVisibleFieldsEmpty = false;
                     }
                  }

                  if (!allVisibleFieldsEmpty) isTableValid = false;
               } else {
                  let allVisibleFieldsEmpty = true;

                  const fieldValues = Object.entries(values);

                  for (const [key, value] of fieldValues) {
                     if (
                        allVisibleFieldsEmpty &&
                        value !== undefined &&
                        value !== null &&
                        value !== "" &&
                        !document.querySelector(`[column="${key}"]`)?.classList?.contains("hidden")
                     ) {
                        allVisibleFieldsEmpty = false;
                     }
                  }

                  if (!allVisibleFieldsEmpty) {
                     // For some reason backend told us that we have to include this property
                     gridRequestObject[idx] = {
                        ...ref.getFieldsValue(),
                        [`updated${gridRequestFieldId}`]: "true",
                     };
                     idx++;
                  }
               }
            });
         }
      });
      return { isTableValid, gridData: { [gridRequestFieldId]: gridRequestObject } };
   } else {
      return { isTableValid, gridData: {} };
   }
};

export const handleInputBlockade = (e) => {
   // This makes sure that user can't just delete 'disabled' attribute from HTML and change the value
   // of the field
   if (e.preventDefault) {
      e.preventDefault();
   }
   return false;
};

export const getDependentFieldValue = (field, form, formData) => {
   let fieldValue = form.getFieldValue(field.techname);
   const fieldData = Object.values(formData.forms_data.tab[0].elements).find(
      (el) => el.tech_name === field.techname,
   );
   if (fieldData?.type === "select") {
      fieldValue = Object.entries(fieldData.options).find(
         ([key, label]) => label === fieldValue,
      )?.[0];
   }
   if (typeof fieldValue === "boolean") {
      return fieldValue ? "1" : "0";
   }
   return fieldValue || "";
};

export const resolveDependentFields = (
   arrayOfFields,
   dependencyType,
   operation,
   form,
   formData,
) => {
   let returnValue = false;
   for (const field of arrayOfFields) {
      //No comments
      field.techname = field.tech_name || field.techname;
      let dependentFieldValue = getDependentFieldValue(field, form, formData);
      if (
         isNaN(+dependentFieldValue) && isNaN(+field.value)
            ? field.value === dependentFieldValue
            : +field.value === +dependentFieldValue
      ) {
         returnValue = field[dependencyType] === operation;
      } else {
         return field[dependencyType] !== operation;
      }
   }
   return returnValue;
};

export const isFieldVisible = (element, form, formData) => {
   const { hidden, showHideFields } = element;
   if (showHideFields && showHideFields.length > 0) {
      return resolveDependentFields(showHideFields, "state", "show", form, formData);
   }
   if (hidden === "1") return false;
   return true;
};

export const isFieldRequired = (element, form, formData) => {
   try {
      const { showHideFields, obow } = element;
      const isNotAlwaysRequired = showHideFields.some(
         (filter) => filter.required === "not_always_required",
      );
      const requiredDependencies = JSON.parse(element.object?.UIP_REQUIRED_CONTROL || "[]");
      const isAnyDependency =
         Array.isArray(requiredDependencies) && requiredDependencies.length > 0;
      let dependencyRequired = isAnyDependency;
      isAnyDependency &&
         requiredDependencies.forEach((dependency) => {
            if (dependency.state === "required") {
               if (dependency.value != form.getFieldValue(dependency.techname)) {
                  dependencyRequired = false;
               }
            }
         });
      dependencyRequired = dependencyRequired || obow === "1";

      if (!isNotAlwaysRequired) return dependencyRequired;
      return (
         isFieldVisible(element, form, formData) &&
         (element.object?.UIP_OBOW === "1" || dependencyRequired)
      );
   } catch {
      return false;
   }
};

export const validateFormFields = async (formData, formRef, setFieldsInfo, intl) => {
   const formElements = formData?.forms_data?.tab[0]?.elements;

   // We create a list of fields that are required
   const requiredElements = Object.values(formElements).filter(
      (field) => isFieldRequired(field, formRef, formData),
      // (field) => isFieldRequired(field, formRef, formData) || field.hasAlert
   );
   // Reset the styles for elements in the technamesToResetStyle list
   // Create an empty list for fields that have invalid values
   const invalidFields = [];

   for (const el of requiredElements) {
      const value = formRef?.getFieldValue(el.tech_name);

      // Check if the field meets the conditions to be considered invalid
      if (el.type !== "section" && (value === null || value === undefined || value === "")) {
         // Add the field to the list if it doesn't meet the requirements
         invalidFields.push(el.tech_name);
         setFieldsInfo((prev) => ({
            ...prev,
            [el.tech_name]: intl.formatMessage({ id: "field.required" }),
         }));
      }
   }

   // If there are no invalid fields, return true
   if (invalidFields?.length === 0) {
      return true;
   } else {
      return false;
   }
};

export const validateForm = async (uuid, actionName, formData, setFieldsInfo, intl) => {
   const formRef = store?.getState()?.formsv2?.formInfo?.[uuid]?.mainFormRef;
   let returnData = {
      isFormValid: false,
      gridData: {},
   };
   if (!formRef) return returnData;

   const { isTableValid, gridData } = validateGridRows();
   const isFormValid = await validateFormFields(formData, formRef, setFieldsInfo, intl);
   // by this condition, we are checking if we should include template validation when saving form, and if so, we are checking if template comes in good shape
   if (isFormValid) {
      // If there are no errors in main form and isTableValid is true, we just set isFormValid to true
      returnData = { isFormValid: isTableValid, gridData };
   } else {
      if (actionName === "askQuestion" || actionName === "moveForward" || actionName === "answer") {
         returnData = { isFormValid: isTableValid, gridData };
      }
   }
   return returnData;
};

export const handleInitialSqlValues = (elements, gridDataId) => {
   try {
      const initialSqlValues = {};
      elements.forEach((element) => {
         if (element?.type === "sql") {
            if (element.sqlValues?.length > 0) {
               const sqlAvailableOptions = [];
               element.sqlValues.forEach((sqlOption) => {
                  sqlAvailableOptions.push({
                     value: sqlOption?.value,
                     label: sqlOption?.label,
                  });
               });
               initialSqlValues[element.tech_name] = sqlAvailableOptions;
            }
         }
      });
      if (gridDataId) {
         store.dispatch(setGridSqlValues({ [gridDataId]: initialSqlValues }));
      } else {
         store.dispatch(setSqlValues(initialSqlValues));
      }
   } catch {
      // TODO: add translation to this error message
      Message.error("Error while processing sql values");
   }
};
